import { render, staticRenderFns } from "./KindIdentifierSelector.vue?vue&type=template&id=0972bffa&"
import script from "./KindIdentifierSelector.vue?vue&type=script&lang=js&"
export * from "./KindIdentifierSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports